// src/common/js/menus.js
import Vue from 'vue';

// 注册全局自定义指令 `v-menus`
Vue.directive('menus', {
    bind: (el, binding) => {
        checkMenuPermission(el, binding);
    },
    update: (el, binding) => {
        checkMenuPermission(el, binding);
    }
});

// 检查菜单权限的函数
function checkMenuPermission(el, binding) {
    const menuName = binding.value;

    // 从本地存储获取用户菜单权限
    let userMenus = [];
    try {
        const menusData = localStorage.getItem('menus');
        if (menusData) {
            const parsedMenus = JSON.parse(menusData);
            // 提取所有子菜单的名称
            parsedMenus.forEach(menu => {
                if (menu.children && Array.isArray(menu.children)) {
                    menu.children.forEach(child => {
                        if (child.name) {
                            userMenus.push({ name: child.name });
                        }
                    });
                }
            });
        }
    } catch (e) {
        console.warn('解析用户菜单数据失败:', e);
    }

    // 检查用户是否有该菜单权限
    const hasPermission = userMenus.some(menu => menu.name === menuName);

    // 根据权限控制显示/隐藏
    el.style.display = hasPermission ? '' : 'none';
}

// 导出获取用户有权限菜单的函数，供其他组件使用
export function getUserAllowedMenus() {
    // 从本地存储获取用户菜单权限
    let userMenus = [];
    try {
        const menusData = localStorage.getItem('menus');
        if (menusData) {
            const parsedMenus = JSON.parse(menusData);
            // 提取所有子菜单的名称
            parsedMenus.forEach(menu => {
                if (menu.children && Array.isArray(menu.children)) {
                    menu.children.forEach(child => {
                        if (child.name) {
                            userMenus.push({ name: child.name });
                        }
                    });
                }
            });
        }
    } catch (e) {
        console.warn('解析用户菜单数据失败:', e);
    }

    // 返回用户有权限的菜单列表（只返回在预定义范围内的菜单）
    const allowedMenus = ["客户列表", "我的客户", "订单列表", "我的订单列表", "审核管理", "产品列表"];
    return userMenus
        .map(menu => menu.name)
        .filter(menuName => allowedMenus.includes(menuName));
}



// WEBPACK FOOTER //
// ./src/model/menus.js